import React, { Component } from 'react';
import {baseUrl} from '../../url';
import moment from 'moment';

class GeneXpert extends Component{
    constructor(){
        super()
        this.state = {
            date: '',
            type: 'genexpert',
            mtb: '',
            rif: '',
            success: false,
            response: true,
        }
    }

    handleChange = (e) =>{
        this.setState({ 
            [e.target.name]: e.target.value,
            [e.target.name + 'Error']: ''
        });
        if(e.target.name === 'date'){
            let date  = moment(e.target.value).format('YYYY-MM-DD HH:mm:ss')
            this.setState({
                date
            })
        }
    }
    close = () => {
        setTimeout(() => { 
            this.props.handleClose();
        }, 1000);
    }
    handleSubmit = (e) => {
        e.preventDefault();
        const {type, date , mtb, rif, mtbError, rifError} = this.state;

        if(!date){
            this.setState({
                dateError: 'Please enter a valid date'
            })
        }
        if(!mtb){
            this.setState({
                mtbError: 'This field cannot be empty'
            })
        }
        if(mtb){
            if(!rif){
                this.setState({
                    rifError: 'This field cannot be empty'
                })
            }
        }
        if(date && mtb && !mtbError && !rifError){
            this.setState({
                response: false
            })
            const token = localStorage.getItem('access_token');
            const id = localStorage.getItem('user_id');
            let retries = 0;
            let entry = {
                'treatment_date': date,
                'mtb': mtb === 'yes'? true : false,
                type,
            };
            if(mtb === 'yes'){
                entry = {
                    ...entry,
                    rif
                }
            };
            fetch(`${baseUrl}/admin/patients/tests/${id}`,{
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': token,
                },
                body: JSON.stringify(entry)
            })
            .then(response => {
                const auth = response.headers.get('Authorization');
                localStorage.setItem('access_token', auth);
                return response.json();
            })
            .then(responseJson => {
                this.setState({
                    response: true
                })
                if (responseJson.hasOwnProperty('_meta')){
                   if(responseJson._meta._status === 202){
                       this.setState({
                           success: true,
                           message: responseJson.message
                       }, () => {
                           this.props.hideField();
                           this.props.refresh();
                           this.close();
                       })
                   }
                }
            })
            .catch((error) => {
                if (error === 401 && retries < 1) {
                    localStorage.getItem('access_token')
                        .then(value => {
                            fetch(`${baseUrl}/token/refresh`, {
                                headers: {
                                    'Accept': 'application/json',
                                    'Authorization': value
                                }
                            }).then(response => {
                                retries += 1;
                                if (response.status === 200) {
                                    localStorage.setItem('access_token', response.headers.get('Authorization'));
                                    this.handleSubmit();
                                }
                                else {
                                    alert('something went wrong please try again later');
                                }
                            })
                        })
                }
                else {
                    alert('something went wrong please try again later');
                }
            })
        }
    }
    render(){
        const {success, mtb} = this.state;
        return(
            <React.Fragment>
                {
                    !success &&
                    <React.Fragment>
                        <label>
                            Date test was taken
                            <input type="date" onChange={this.handleChange} name="date" className={this.state.dateError ? 'error-input' : ''} />
                            <span className="error-text">{this.state.dateError}</span>
                        </label>
                        <label>
                            MTB Detected
                            <select onChange={this.handleChange} name="mtb" className={this.state.mtbError ? 'error-input' : ''} >
                                <option>Select...</option>
                                <option value="yes">Yes</option>
                                <option value="no">No</option>
                            </select>
                            <span className="error-text">{this.state.mtbError}</span>
                        </label>
                        {
                            mtb === 'yes' &&
                            <label>
                                RIF Resistance
                                <select onChange={this.handleChange} name="rif" className={this.state.rifError ? 'error-input' : ''} >
                                    <option>Select...</option>
                                    <option value="detected">Detected</option>
                                    <option value="not-detected">Not Detected</option>
                                    <option value="indeterminate">Indeterminate</option>
                                </select>
                                <span className="error-text">{this.state.rifError}</span>
                            </label>
                        }
                        <button onClick={this.handleSubmit}>
                            Save
                            {
                                !this.state.response &&
                                <i className="fa fa-spinner fa-pulse fa-fw" />
                            }
                        </button>
                    </React.Fragment>
                }
                {
                    this.state.success &&
                    <div className="check">
                        <div className="svg-div">
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
                                <circle className="path circle" fill="none" stroke="#14DA9E" strokeWidth="6" strokeMiterlimit="10" cx="65.1" cy="65.1" r="62.1" />
                                <polyline className="path check" fill="none" stroke="#14DA9E" strokeWidth="6" strokeLinecap="round" strokeMiterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 " />
                            </svg>
                        </div>
                        <p><small>{this.state.message}</small></p>
                    </div> 
                }
            </React.Fragment>
        )
    }
}

export default GeneXpert;


// WEBPACK FOOTER //
// ./src/components/patientProfile/testForms/geneXpert.js